import React from "react";

export default function Ex2_Training() {
  return (
    <div>
      <h1>Ex2_Training</h1>
      <p>This is the Ex2_Training component.</p>
    </div>
  );
}
